import * as React from 'react';
import {
    RichUtils,
    EditorState,
    ContentState,
    ContentBlock,
} from 'draft-js';


export const colorStrategy = (contentBlock: ContentBlock, callback: any, contentState: ContentState) => {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            return (
                entityKey !== null &&
                contentState.getEntity(entityKey).getType() === 'TEXTCOLOR'
            );
        },
        callback
    );
};


export const TextColor = (props: any) => {
    const { contentState, entityKey } = props;
    const { color } = contentState.getEntity(entityKey).getData();
    return (
        <span style={{ color: color }}>{props.children}</span>
    );
};

const textColorPlugin = {
    keyBindingFn(event: any, other: any) {
        const { getEditorState } = other;
        const editorState = getEditorState();
        const selection = editorState.getSelection();
        // Don't do anything if no text is selected.
        if (selection.isCollapsed()) {
            return;
        }
        if (event.altKey && event.key === 'c') {
            return 'text-color'
        }
    },

    handleKeyCommand(command: string, editorState: EditorState, other: any) {
        const { setEditorState } = other;
        if (command !== 'text-color') {
            return 'not-handled';
        }
        const selection = editorState.getSelection();
        const color = 'red'
        const content = editorState.getCurrentContent();
        const contentWithEntity = content.createEntity('TEXTCOLOR', 'MUTABLE', { color: color });
        const newEditorState = EditorState.push(editorState, contentWithEntity, 'apply-entity');
        const entityKey = contentWithEntity.getLastCreatedEntityKey();
        setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey))
        return 'handled';
    },

    decorators: [{
        strategy: colorStrategy,
        component: TextColor,
    }],
};

export default textColorPlugin;